<div class="drag-drop-container">
  <div
    class="dropzone mat-typography"
    (drop)="onDrop($event)"
    (dragover)="onDragover($event)"
    (dragleave)="onDragleave($event)"
    [class.active]="isStyling"
    (click)="fileInput.click()"
    data-test="gsm-drag-drop-dokument-picker_dropzone"
  >
    <div class="dropzone-label">Dateien hierher ziehen oder klicken um eine Datei hochzuladen</div>
    <input
      hidden
      type="file"
      #fileInput
      (change)="manualUpload($event)"
      [accept]="acceptString"
      multiple
      data-test="gsm-drag-drop-dokument-picker_file-input"
    />
  </div>

  <form [formGroup]="uploadForm" class="drag-drop-form">
    <div formArrayName="fileInfo" class="file-list">
      <div *ngFor="let fi of fileInfo.controls; let i = index">
        <div [formGroupName]="i" class="file">
          <mat-form-field class="file-specify">
            <mat-label>Dokumenttyp</mat-label>
            <mat-select required formControlName="type" data-test="gsm-drag-drop-dokument-picker_select-dokument-typ">
              <mat-option *ngFor="let option of documentTypes" [value]="option">
                {{ option.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="file-name">
            <input
              data-test="gsm-drag-drop-dokument-picker_input-file-name"
              matInput
              placeholder="Hinzugefügte Datei"
              [value]="files[i]?.name"
              disabled
            />
          </mat-form-field>

          <button
            type="button"
            mat-icon-button
            aria-label="Delete Button"
            class="file-delete"
            (click)="removeEntry(i)"
            data-test="gsm-drag-drop-dokument-picker_delete-btn"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
